import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse API error response detail field into a readable string.
 * Handles FastAPI validation errors which can be strings, arrays, or objects.
 * @param {any} detail - The error detail from the API response
 * @param {string} fallback - Fallback message if detail is not available
 * @returns {string} Human-readable error message
 */
export function parseApiError(detail, fallback = 'An error occurred') {
  if (!detail) {
    return fallback;
  }
  if (typeof detail === 'string') {
    return detail;
  }
  if (Array.isArray(detail)) {
    // Handle FastAPI validation error array format with null safety
    const messages = detail
      .filter(err => err !== null && err !== undefined)
      .map(err => err.msg || err.message || 'Validation error');
    return messages.length > 0 ? messages.join(', ') : fallback;
  }
  if (typeof detail === 'object') {
    // Only extract safe, known properties to avoid exposing sensitive data
    return detail.msg || detail.message || fallback;
  }
  return fallback;
}
